module.exports = "/_next/static/images/0ff66a5ac271bdcf58edcec70ec2180f-phone-mobile.png.webp";